import type { Department } from '@/types/api'
import { createCrudService } from '../crud'

export type DepartmentInput = Pick<Department, 'name_en' | 'name_ru' | 'name_uz' | 'name_cyr' | 'status' | 'branch_ids'>

export const departmentsService = createCrudService<Department, DepartmentInput>('departments')
